<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
import Loader from "@/components/widgets/loader";
import { uuid } from 'vue-uuid';  
import satdosyamalzeme from "@/models/satdosyamalzeme";
import XLSX from "xlsx"

export default {
   mixins: [Api, Sabit, satdosyamalzeme],
  props: ["Id", "satdosyaId"],

    components: {
    Loader,

  },
  data() {
    return {
       uuid: uuid.v4(),  

        FormData: [],
        Message: {
        position: "",
        icon: "",
        title: "",
        showConfirmButton: false,
        timer: 1500,
      },

           
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormElemanlari:[
      
      ],
      TabloVerileri: [],
      TabloDetayVerileri: [],
      Parametreler:[],
      ComboboxDonemler:[],
      ExceldenOkunan:[],
      veri_tipleri:[],
      hesap_parametre:"",
      hesap_yontemi:0,
      hesaplanan_parametre:"",
      keys:[],
      degerler:[],
      DataUpdate:"",
      AddEdit:"",
      okunanverijson:[],
      excel_kayit_listesi:[],

       Filter: {
        secilen_Donem: "",
        aktarilan_donem: "",
      },

    };
  },


  watch: {
    Id() {
 
    },

    satdosyaId() {
      this.Get();
    },
  },

  methods: {
    Get(){
    },
    onSubmit(){
      this.parametre_kontrol(1);
    },

    parametre_kontrol(islem){


      if(islem == 2){
       this.ActionsFilterGet({Service:"OKeyValues", Page:this.Page, Filter: "&Tip=201&Kod=1"}).then((res) => {

  this.okunanverijson.forEach((dataItem) => {

    var omalzeme = {
      Deleted: false,
      Adi: dataItem.Malzeme,
      Olcubirimi: res.Data[0].Id,   //adet
      Kayittarihi: new Date(),
      Grupid: null,
      Aciklama: dataItem.Aciklama.toString(),
      Image: "string"
    };

    this.Post("omalzeme", omalzeme, false).then((resp) => {
      if (resp) {

        var osatdosyamalzeme = {
          Dosyaid: this.satdosyaId,
          Sirano: dataItem.Sira, // Sıra burada doğru olmalı
          Malzemeid: resp,
          Olcubirimi: res.Data[0].Id,
          Adet: dataItem.Adet,
          Aciklama: dataItem.Aciklama.toString(),
          Deleted: false
        };

        this.Post("satdosyamalzeme", osatdosyamalzeme).then((res) => {
          if (res) {
            this.$emit("TableUpdate");
          }
        });

      }
    });

  });

  this.$bvModal.hide("ExcelOku");
});

    }


    },

    onChange(event) {
      this.okunanverijson=[];
      this.file=null;

      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: 'binary' , cellDates: true, dateNF: 'yyyy/mm/dd;@'});
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          this.ExceldenOkunan = XLSX.utils.sheet_to_json(ws, { header: 1 });

          
              if (this.ExceldenOkunan[0].length==this.FormElemanlari.length){
                      let satir="";
                      for (var i=1;i<this.ExceldenOkunan.length;i++){
                        satir="";
                        var Data={}
                          for (var baslik=0;baslik<this.ExceldenOkunan[0].length;baslik++){
                              if (satir!="") { satir=satir+",";} else {satir=satir+"{";}
                              satir=satir+""+this.ExceldenOkunan[0][baslik]+":"+this.ExceldenOkunan[i][baslik];
                              Data.[this.ExceldenOkunan[0][baslik]] = this.ExceldenOkunan[i][baslik]
                          }  
                          satir=satir+"}";

                        this.okunanverijson.push(Data);    
                        
                      }

            
                      for (i=0; i< this.okunanverijson.length;i++ ){
                  
                      var keyCount  = Object.keys(this.okunanverijson[i]).length;

                        for (var s=0; s<keyCount;s++){   
                          
                            if(this.FormElemanlari[s].FieldType=="Tarih"){

                              let deger =  new Date(Object.values(this.okunanverijson[i])[s]);
                              deger.setDate(deger.getDate() + 1);

                              let yeni = this.$options.filters.formatDateTable(deger)
                            
                              this.okunanverijson[i].[Object.keys(this.okunanverijson[i])[s]]= yeni;
                                
                            }

                        }

                      }
            } else {
                this.$toast.error(
                    this.$t("Excel Tablosu Parametre Sayısı Hatalı!")                  
                );
            }
         
        }

        reader.readAsBinaryString(this.file);
      }
    },
    ExcelSil(satir){
      this.okunanverijson.splice(satir,1);
    },


  },

  created() {
    for(var Data in this.FormDataType){
      if(this.FormDataType[Data].FieldName != 'Dosyaid'){
        this.FormElemanlari.push({"FieldTitle" :this.FormDataType[Data].FieldName, "FieldType" : this.FormDataType[Data].FieldType, 
                  });
      }
 

    }


  },

};
</script>

<template>
  <Loader>
    <b-modal
      id="ExcelOku"
      size="lg"
      title="Malzemeleri Excel'den Aktar"
      title-class="font-18"
      hide-footer
    >
      <div class="alert alert-primary" role="alert">
        <a href="/assets/OrnekMalzemeListesi.xlsx" download="ornekMalzemeDosyasi.xlsx">Örnek dosya</a>yı indiriniz ve doldurunuz ya da ekleyeceğiniz belgenin sütunlarını <a href="/assets/OrnekMalzemeListesi.xlsx" download="ornekMalzemeDosyasi.xlsx">örnek dosya</a>ya göre düzenleyiniz.
        
      </div>
      <br>
       <input class="form-control" @change="onChange" type="file" id="formFile"/>
       <br>

      <div class="table-responsive">
        <table class="table table-striped table-bordered mb-0">
                <thead>
                  <tr style="text-align: center;">
                    <th>Sıra</th>
                    <th>Malzeme</th>
                    <th>Ölçü</th>
                    <th>Adet</th>
                    <th>Aciklama</th>
                    <th>İşlem</th>
                  </tr>
                </thead>
              <tr v-for="(DataSatir,index) in okunanverijson" :key="index" style="text-align: center;">
                <td v-for="(Data,index) in DataSatir" :key="index"> {{Data}}</td>
                <td>

                  <i
                      style="margin-left:10px"
                      @click="ExcelSil(index)"  
                      class="fas fa-trash-alt"
                    >
                    </i>

                </td>
              </tr>
       </table>
       </div>
       <br>
          <button class="btn btn-primary" @click="parametre_kontrol(2)">Kaydet</button>
    </b-modal>
    </Loader>
</template>
